import { useContext } from "react";

import { HeaderContext } from "./HeaderContext";

export const useHeaderContext = (): HeaderContext => {
  const context = useContext(HeaderContext);
  if (context === null) {
    throw new Error(
      "useHeaderContext must be used within a HeaderContextProvider",
    );
  }
  return context;
};
